import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { buildStoreConfig } from '../storeAliasHelper';

export const dayTransparentGlassesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 7999,
        variantId: '42330065567814',
        shopifyVariantId: 'gid://shopify/ProductVariant/42330065567814',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/42330065567814:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 99,
        variantId: '42378356654140',
        shopifyVariantId: 'gid://shopify/ProductVariant/42378356654140',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/42378356654140:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 99,
        variantId: '41453042008160',
        shopifyVariantId: 'gid://shopify/ProductVariant/41453042008160',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41453042008160:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 355,
        variantId: '51986382291315',
        shopifyVariantId: 'gid://shopify/ProductVariant/51986382291315',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/51986382291315:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 91,
        variantId: '54831405498742',
        shopifyVariantId: 'gid://shopify/ProductVariant/54831405498742',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/54831405498742:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 79,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 169,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 149,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 999,
      },
      [ShopifyStore.JP]: {
        price: 13800,
      },
      [ShopifyStore.MX]: {
        price: 2031,
      },
    })
  : buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 7999,
        variantId: '40858435158089',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858435158089',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40858435158089:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 99,
        variantId: '40858435158089',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858435158089',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40858435158089:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 99,
        variantId: '40858435158089',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858435158089',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40858435158089:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 355,
        variantId: '40858435158089',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858435158089',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40858435158089:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 91,
        variantId: '40858435158089',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858435158089',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/40858435158089:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 79,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 169,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 149,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 999,
      },
      [ShopifyStore.JP]: {
        price: 13800,
      },
      [ShopifyStore.MX]: {
        price: 2031,
      },
    });
